import React, {useEffect, useRef, useState} from "react"
import PropTypes from "prop-types"
import {Card, CardBody, Col, Container, Form, Row} from "reactstrap"
import {connect} from "react-redux"

//Date Picker
import {registerLocale, setDefaultLocale} from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import "assets/scss/datatables.scss"
import ptBR from "date-fns/locale/pt-BR"
import moment from "moment"
import momentTimezone from "moment-timezone"
import {buscarNotasSituacoes} from "../../store/auth/profile/actions"
import OverView from "./overview"
import CardWelcome from "./card-welcome"
import MiniWidget from "./mini-widget"
import { getDashboardData } from "../../store/dashboard/actions"
import NotasTable from "./notas-table"
import {Filters} from "../../common/data/definitions"
import FormFilterSelect from "../../components/Common/form-filter-select"
import FormFilterPeriod from "../../components/Common/form-filter-period"
import {
    getPeriodsStartEndDateByType,
    isNotEmpty
} from "../../helpers/utils"
import FormFilterCompany from "../../components/Common/form-filter-company"
import {withTranslation} from "react-i18next";
import { navegarBreadCrumb } from "../../store/navigator/actions"
import { decodeToken } from "react-jwt"
import { notesReportLoginToken, setDashboardFilters } from "../../store/auth/login/actions"
import { withRouter } from "react-router-dom"

registerLocale("ptBR", ptBR)
setDefaultLocale("ptBR")

const brazilMoment = (...args) => momentTimezone(...args)

const NotasEmitidasSemAutenticacao = props => {

    const ref = useRef();

    const [startDate, setStartDate] = useState(
        moment().subtract(30, "days").toDate()
    )
    const [endDate, setEndDate] = useState(new Date())

    const [situation, setSituation] = useState("")
    const [periods, setPeriods] = useState([])
    const [period, setPeriod] = useState(null)
    const [tipoNota, setTipoNota] = useState("")
    const [totalNotas, setTotalNotas] = useState(null)
    const [filters, setFilters] = useState(null)
    const [companies, setCompanies] = useState([])
    const [companiesOptions, setCompaniesOptions] = useState([])
    const [company, setCompany] = useState()

    const usePermissionListar = false

    const [reports, setReports] = useState([
        {
            id: 'notashoje',
            title: props.t('notasemitidas.lista.notashoje.label'),
            tooltip: props.t('notasemitidas.lista.notashoje.tooltip'),
            icon: "mdi mdi-note-multiple-outline",
            color: "warning",
            value: "",
            desc: "",
            loading: true
        },
        {
            id: 'notasmes',
            title: props.t('notasemitidas.lista.notasmes.label'),
            tooltip: props.t('notasemitidas.lista.notasmes.tooltip'),
            icon: "mdi mdi-note-multiple-outline",
            color: "primary",
            value: "",
            desc: "",
            loading: true
        },
        {
            id: 'notasano',
            title: props.t('notasemitidas.lista.notasano.label'),
            tooltip: props.t('notasemitidas.lista.notasano.tooltip'),
            icon: "mdi mdi-note-multiple-outline",
            color: "info",
            value: "",
            desc: "",
            loading: true
        }
    ])

    useEffect(() => {
        const paramsDashboardReport = props.match.params.hasOwnProperty("notesReport")
        if (paramsDashboardReport) {
            try {
                const param = props.match.params.notesReport
                props.notesReportLoginToken(param)

                const decodedToken = decodeToken(param)

                const { periodStart, periodEnd } = getPeriodsStartEndDateByType(decodedToken.periodo)
                const dateStartStr = periodStart.format("YYYY-MM-DD 00:00:00")
                const dateEndStr = periodEnd.format("YYYY-MM-DD 23:59:59")

                props.setDashboardFilters({
                    periodStart: dateStartStr,
                    periodEnd: dateEndStr,
                    companiesId: [decodedToken.id]
                })

                const selectedCompanyFromToken = {value: decodedToken.id, label: decodedToken.nome}
                setCompany(decodedToken.id)
                setPeriod(decodedToken.period)
                setStartDate(periodStart)
                setEndDate(periodEnd)
                setPeriods([{label: "Mês", value: 'month'}])

                setCompanies([selectedCompanyFromToken])
                setCompaniesOptions([selectedCompanyFromToken])

                populateFiltros(selectedCompanyFromToken.value, dateStartStr, dateEndStr)

                props.getDashboardData(null, null, [decodedToken.id], "notasSemanas")
                props.getDashboardData(null, null, [decodedToken.id], "notasMeses")
                props.getDashboardData(null, null, [decodedToken.id], "notasAnos")
            } catch (e) {
                console.error(e)
            }

        }
    }, [])

    const describeDiff = (A, B, numberOnly = false) => {
        A = parseFloat(A)
        B = parseFloat(B)

        const diff = A && B ? (100 * Math.abs((B - A) / B)).toFixed(2) : 0

        if (numberOnly) {
            return parseInt(diff)
        }

        return A >= B ? `+ ${diff} %` : `- ${diff} %`
    }

    const abbreviateNumber = (num, fixed) => {
        if (num === null) {
            return null
        } // terminate early
        if (num === 0) {
            return "0"
        } // terminate early
        fixed = !fixed || fixed < 0 ? 0 : fixed // number of decimal places to show
        var b = num.toPrecision(2).split("e"), // get power
            k = b.length === 1 ? 0 : Math.floor(Math.min(b[1].slice(1), 14) / 3), // floor at decimals, ceiling at trillions
            c =
                k < 1
                    ? num.toFixed(0 + fixed)
                    : (num / Math.pow(10, k * 3)).toFixed(1 + fixed), // divide by power
            d = c < 0 ? c : Math.abs(c), // enforce -0 is 0
            e = d + ["", "K", "M", "B", "T"][k] // append power
        return e
    }

    const weekdayName = dia_numerico => {
        return [
            "Segunda",
            "Terça",
            "Quarta",
            "Quinta",
            "Sexta",
            "Sábado",
            "Domingo"
        ][dia_numerico]
    }

    const monthName = month => {
        return [
            null,
            "Jan",
            "Fev",
            "Mar",
            "Abr",
            "Mai",
            "Jun",
            "Jul",
            "Ago",
            "Set",
            "Out",
            "Nov",
            "Dez"
        ][month]
    }

    useEffect(() => {
        setReports([
            {
                id: 'notashoje',
                title: props.t('notasemitidas.lista.notashoje.label'),
                tooltip: props.t('notasemitidas.lista.notashoje.tooltip'),
                icon: "mdi mdi-note-multiple-outline",
                color: "warning",
                value:
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo &&
                    Array.isArray(props.dashboardNotasSemanas.periodo) &&
                    props.dashboardNotasSemanas.periodo.length
                        ? parseFloat(
                            props.dashboardNotasSemanas.periodo[0][0].total_nf || 0
                        ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : 0,
                desc: describeDiff(
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo &&
                        Array.isArray(props.dashboardNotasSemanas.periodo) &&
                        props.dashboardNotasSemanas.periodo.length
                        ? props.dashboardNotasSemanas.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasSemanas &&
                        props.dashboardNotasSemanas.periodo_anterior &&
                        Array.isArray(props.dashboardNotasSemanas.periodo_anterior) &&
                        props.dashboardNotasSemanas.periodo_anterior.length
                        ? props.dashboardNotasSemanas.periodo_anterior[0][0].total_nf || 0
                        : 0
                ),
                loading: props.loadingDashboardNotasSemanas,
                series: [
                    {
                        name: "Valor",
                        data:
                            props.dashboardNotasSemanas && props.dashboardNotasSemanas.semana &&
                            Array.isArray(props.dashboardNotasSemanas.semana) &&
                            props.dashboardNotasSemanas.semana.length
                                ? props.dashboardNotasSemanas.semana[0].map(e => e.total_nf)
                                : []
                    }
                ],
                diff: describeDiff(
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo &&
                        Array.isArray(props.dashboardNotasSemanas.periodo) &&
                        props.dashboardNotasSemanas.periodo.length
                        ? props.dashboardNotasSemanas.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasSemanas && props.dashboardNotasSemanas.periodo_anterior &&
                        Array.isArray(props.dashboardNotasSemanas.periodo_anterior) &&
                        props.dashboardNotasSemanas.periodo_anterior.length
                        ? props.dashboardNotasSemanas.periodo_anterior[0][0].total_nf || 0
                        : 0,
                    true
                ),
                options: {
                    chart: {sparkline: {enabled: !0}},
                    stroke: {curve: "smooth", width: 2},
                    colors: ["#f1b44c"],
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: !1,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        }
                    },
                    tooltip: {
                        fixed: {enabled: !1},
                        x: {show: !1},
                        marker: {show: !1}
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val, object) {
                                if (object) {
                                    return (
                                        weekdayName(
                                            Array.isArray(props.dashboardNotasSemanas) && props.dashboardNotasSemanas.length ?
                                                props.dashboardNotasSemanas.semana[0][object.dataPointIndex].weekday : 0) +
                                        " " +
                                        abbreviateNumber(val)
                                    )
                                }
                            }
                        }
                    }
                }
            },
            {
                id: 'notasmes',
                title: props.t('notasemitidas.lista.notasmes.label', { data: (brazilMoment(props.currentPeriod).format(
                    "MMM"
                ))}),
                tooltip: props.t('notasemitidas.lista.notasmes.tooltip'),
                icon: "mdi mdi-note-multiple-outline",
                color: "primary",
                value:
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo)
                        ? parseFloat(
                            props.dashboardNotasMeses.periodo[0][0].total_nf || 0
                        ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : 0,
                desc: describeDiff(
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo)
                        ? props.dashboardNotasMeses.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo_anterior)
                        ? props.dashboardNotasMeses.periodo_anterior[0][0].total_nf || 0
                        : 0
                ),
                loading: props.loadingDashboardNotasMeses,
                series: [
                    {
                        name: "Valor",
                        data:
                            props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.meses)
                                ? props.dashboardNotasMeses.meses[0].map(e => e.total_nf)
                                : []
                    }
                ],
                diff: describeDiff(
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo)
                        ? props.dashboardNotasMeses.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasMeses && isNotEmpty(props.dashboardNotasMeses.periodo_anterior)
                        ? props.dashboardNotasMeses.periodo_anterior[0][0].total_nf || 0
                        : 0,
                    true
                ),
                options: {
                    chart: {sparkline: {enabled: !0}},
                    stroke: {curve: "smooth", width: 2},
                    colors: ["#f1b44c"],
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: !1,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        }
                    },
                    tooltip: {
                        fixed: {enabled: !1},
                        x: {show: !1},
                        marker: {show: !1}
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val, object) {
                                if (object) {
                                    return (
                                        monthName(Array.isArray(props.dashboardNotasMeses) && props.dashboardNotasMeses.length ?
                                          props.dashboardNotasMeses.meses[0][object.dataPointIndex].month : 0
                                        ) +
                                        " " +
                                        abbreviateNumber(val)
                                    )
                                }
                            }
                        }
                    }
                }
            },
            {
                id: 'notasano',
                title: props.t('notasemitidas.lista.notasano.label', { data: (brazilMoment(props.currentPeriod).format(
                        "YY"
                    ))}),
                tooltip: props.t('notasemitidas.lista.notasano.tooltip'),
                icon: "mdi mdi-note-multiple-outline",
                color: "info",
                value:
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo)
                        ? parseFloat(
                            props.dashboardNotasAnos.periodo[0][0].total_nf || 0
                        ).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL"
                        })
                        : 0,
                desc: describeDiff(
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo)
                        ? props.dashboardNotasAnos.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo_anterior)
                        ? props.dashboardNotasAnos.periodo_anterior[0][0].total_nf || 0
                        : 0
                ),
                loading: props.loadingDashboardNotasAnos,
                series: [
                    {
                        name: "Valor",
                        data:
                            props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.meses)
                                ? props.dashboardNotasAnos.meses[0].map(e => e.total_nf)
                                : []
                    }
                ],
                diff: describeDiff(
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo)
                        ? props.dashboardNotasAnos.periodo[0][0].total_nf || 0
                        : 0,
                    props.dashboardNotasAnos && isNotEmpty(props.dashboardNotasAnos.periodo_anterior)
                        ? props.dashboardNotasAnos.periodo_anterior[0][0].total_nf || 0
                        : 0,
                    true
                ),
                options: {
                    chart: {sparkline: {enabled: !0}},
                    stroke: {curve: "smooth", width: 2},
                    colors: ["#f1b44c"],
                    fill: {
                        type: "gradient",
                        gradient: {
                            shadeIntensity: 1,
                            inverseColors: !1,
                            opacityFrom: 0.45,
                            opacityTo: 0.05,
                            stops: [25, 100, 100, 100]
                        }
                    },
                    tooltip: {
                        fixed: {enabled: !1},
                        x: {show: !1},
                        marker: {show: !1}
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val, object) {
                                if (object) {
                                    return (
                                        monthName(Array.isArray(props.dashboardNotasMeses) && props.dashboardNotasMeses.length ?
                                          props.dashboardNotasMeses.meses[0][object.dataPointIndex].month : 0
                                        ) +
                                        " " +
                                        abbreviateNumber(val)
                                    )
                                }
                            }
                        }
                    }
                }
            }
        ])

        return () => setReports([])
    }, [
        props.dashboardNotasSemanas,
        props.dashboardNotasMeses,
        props.dashboardNotasAnos
    ])

    const populateFiltros = (companyId, dateStart, dateEnd) => {
        const filters = [{id: 'nf', value: 0, condition: Filters.greaterThan}]

        filters.push({id: 'idEmpresa', value: [companyId]})
        filters.push({id: 'data_emissao', value: dateStart, condition: Filters.greaterThanOrEqualTo})
        filters.push({id: 'data_emissao', value: dateEnd, condition: Filters.lessThanOrEqualTo})

        setFilters(filters)
    }

    const onPickStartDate = date => {
        setStartDate(date)
        setEndDate(date)
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg="12">
                            <div>
                                <Row>
                                    <OverView company={companies} />

                                    <Col xl="8">
                                        <CardWelcome/>

                                        <Row>
                                            <MiniWidget reports={reports}/>
                                        </Row>
                                    </Col>
                                </Row>

                                <Card>
                                    <CardBody>
                                        <h4 className="card-title mb-3">Notas Emitidas</h4>

                                        <Form>
                                            <Row>
                                                <div className="col-xl col-sm-6">
                                                    <FormFilterCompany
                                                        attribute="companies"
                                                        value={company}
                                                        description="Empresa"
                                                        // setValue={ value => setCompanies(value) }
                                                        options={companiesOptions}
                                                        multiple={ false }
                                                        hasSelectAll={ false }
                                                        disabled={true}
                                                    />
                                                </div>

                                                <FormFilterPeriod
                                                    disabled={true}
                                                    periodValue={period}
                                                    periodChangeHandeler={e => setPeriod(e)}
                                                    options={periods}
                                                    startDateValue={startDate}
                                                    startDateChangeHandeler={e => onPickStartDate(e)}
                                                    endDateValue={endDate}
                                                    endDateChangeHandeler={e => setEndDate(e)}
                                                    t={props.t}
                                                />


                                            </Row>
                                        </Form>
                                    </CardBody>
                                </Card>

                                { filters && <Card>
                                    <CardBody>
                                        <NotasTable ref={ref} filters={filters} usePermissionListar={usePermissionListar}>
                                        </NotasTable>
                                    </CardBody>
                                </Card> }
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )
}

NotasEmitidasSemAutenticacao.propTypes = {
    orders: PropTypes.array,
    onGetOrders: PropTypes.func
}

const mapStatetoProps = state => {
    const {notasSituacoes, notas, empresas, empresasLoading} = state.Profile
    const {
      loadingDashboardNotasSemanas,
      dashboardNotasSemanas,
      loadingDashboardNotasMeses,
      dashboardNotasMeses,
      loadingDashboardNotasAnos,
      dashboardNotasAnos,
    } = state.Dashboard
    const {
        user,
        currentPeriod,
        dashboardFilters
    } = state.Login
    return {
        notasSituacoes,
        notas,
        user,
        loadingDashboardNotasSemanas,
        dashboardNotasSemanas,
        loadingDashboardNotasMeses,
        dashboardNotasMeses,
        loadingDashboardNotasAnos,
        dashboardNotasAnos,
        currentPeriod, dashboardFilters,
        empresas,
        empresasLoading
    }
}

export default withTranslation()(connect(mapStatetoProps, {
    buscarNotasSituacoes,
    getDashboardData, navegarBreadCrumb, setDashboardFilters, notesReportLoginToken
})(withRouter(NotasEmitidasSemAutenticacao)))
